<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        block
        v-on="on"
      >
        Delete Batch Transaction
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Batch Transaction"
      text="Delete Batch Transaction"
      class="mb-0"
      :loading="loading"
    >
      <v-container v-if="dialog && !loading">
        <v-row no-gutters>
          <v-col cols="12">
            <v-autocomplete
              v-model="referenceCode"
              :items="referenceCodes"
              label="Reference Code"
              multiple
              deletable-chips
              clearable
              chips
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="searchInput"
              placeholder="Filter employee by name"
              append-icon="search"
              label="Search Employee"
              hide-no-data
              hide-selected
            />
          </v-col>

          <v-col cols="12">
            <v-data-table
              v-model="selectedTransactions"
              v-validate="'required'"
              :error-messages="errors.collect('selectedTransactions')"
              data-vv-name="selectedTransactions"
              data-vv-as="transaction"
              dense
              :items="filteredTransactions"
              :headers="headers"
              disable-pagination
              hide-default-footer
              show-select
              item-key="id"
            >
              <template v-slot:item.amount="{ item }">
                <div>
                  <span>{{ twoDigit(item.amount) }}</span>
                </div>
              </template>

              <template v-slot:top>
                <h5 class="font-weight-bold py-2 mb-0 pl-2">
                  Employee Selection:
                </h5>
              </template>
            </v-data-table>
            <span class="red--text text--lighten-1 caption">{{ errors.first('selectedTransactions') }}</span>
          </v-col>
        </v-row>
      </v-container>
      
      <v-card-actions v-if="!loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="error" 
          class="white--text px-10"       
          @click="submitForm"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      transactions: {
        type: Array,
        required: true,
      },
      payrollCycleTransaction: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        searchInput: '',
        localTransactions: [],
        headers: [
          {
            text: 'Reference Code',
            align: 'left',
            sortable: true,
            value: 'reference_code',
          }, 
          {
            text: 'Payroll Company',
            align: 'left',
            sortable: true,
            value: 'payroll_company',
          },
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'name',
          },
          {
            text: 'DOE',
            align: 'center',
            sortable: true,
            value: 'deduction_or_earning',
          },
          {
            text: 'Amount(RM)',
            align: 'right',
            sortable: true,
            value: 'amount',
          },
        ],
        loading: false,
        referenceCodes: [],
        referenceCode: [],
        selectedTransactions: [],
      }
    },
    computed: {
      filteredTransactions () {
        let _this = this

        _this.searchInput = _this.searchInput.trim()

        let firstLevelFilter = this.localTransactions.filter(item => {
          return !item.reference_code.match(/FD-.*/)
        })

        let secondLevelFilter = this.customFilter(firstLevelFilter)

        let filteredTransactions = secondLevelFilter.filter(function (transaction) {
          return (transaction.name || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1
        })

        return filteredTransactions
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()   

        this.loading = true

        this.$api.payrollTransactionDetails().listReferenceCode(this.payrollCycleTransaction.id)
          .then(res => {
            this.referenceCodes = res.data
          })

        this.localTransactions = []

        this.transactions.map(transaction => {
          transaction.payroll_transaction_details.map(payrollTransactionDetail => {
            this.localTransactions.push({
              'id': payrollTransactionDetail.id,
              'reference_code': payrollTransactionDetail.reference_code,
              'payroll_company': transaction.name,
              'name': payrollTransactionDetail.company_employee.employee.person.name,
              'deduction_or_earning': payrollTransactionDetail.deduction_or_earning.name,
              'amount': payrollTransactionDetail.amount,
            })
          })
        })

        this.loading = false
      },
    },
    methods: { 
      twoDigit ($amount) {
        return (Math.round(($amount / 100) * 100) / 100).toFixed(2)
      },

      customFilter (transactions) {
        if (this.referenceCode.length === 0) return transactions

        return transactions.filter(transaction => {
          let referenceCode = transaction.reference_code

          return _.intersection([referenceCode], this.referenceCode).length > 0
        })
      },
      prepareFormData () {
        return {
          payroll_transaction_detail_ids: this.getPayrollTransactionDetailIds(),
        }
      },      
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.payrollTransactionDetails().batchDelete(this.prepareFormData())
              .then((res) => {
                if (res.status === 200 || res.status === 201) {
                  this.$emit('deleted')                
                  this.$snack({ message: 'Transaction deleted successfully' })

                  this.setDialog(false)                
                }
              })
              .catch((err) => {
                if (err.response.status === 500) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.setProgressing(false)
              })
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      getPayrollTransactionDetailIds () {
        let payrollTransactionDetailIds = []

        this.selectedTransactions.map(item => {
          payrollTransactionDetailIds.push(item.id)
        })

        return payrollTransactionDetailIds
      },
    },
  }
</script>
